<ng-template #loadingempty let-state>
  <div class="splash loading" *ngIf="state === 1">
    <div class="spinner">
      <div></div><div></div><div></div><div></div>
    </div>
  </div>
  <div class="splash empty" *ngIf="state === 2">
    <p>{{ 'Es wurden keine Daten gefunden!' }}</p>
  </div>
</ng-template>
<ng-template #docTemplate let-docElement>
  <div class="md3-card-on-surface app-space width-400"
       style="padding: .5rem; width: 20rem; overflow: hidden; position: relative;">
    <div class="grid-auto-1">
      <ng-container *ngIf="docElement.dokMode !== 'Fragebogen'">
        <div style="cursor: pointer" class="list-avatar-placeholder">
												      <span style="font-size: medium"
                                    [tooltip]="getRessource('tooltip.edit')" flow="right">
												      	<img src="{{excRest.computeUrl('ImageThumbnail',{dokID: docElement.dokID})}}"
                                     (click)="attConfig.showAttachmentPreview(docElement.dokID)" alt=""
                                     class="list-avatar-placeholder"/>
												      </span>
        </div>
      </ng-container>
      <ng-container *ngIf="docElement.dokMode === 'Fragebogen'">
        <div class="typo-center app-space-right_075">
												      <span style="font-size: medium"
                                    [tooltip]="getRessource('tooltip.openQuestionnaire')" flow="right">
												      	<i class="fa-2xl fa-duotone fa-clipboard-list"></i>
												      </span>
        </div>
      </ng-container>
      <div class="layout-auto-1-auto-grid-1-auto grid typo-small">
        <div class="list-metadata" style="margin-left:0">
          <div>
            <ng-container *ngIf="docElement.linked">
              <span flow="left" style="font-size: medium"
                    [tooltip]="getRessource('tooltip.linked')">
                <i class="fal fa-link"></i>
                <ng-container *ngIf="!docElement.dokTrackingPortalShare">
                  &nbsp;-&nbsp;
                </ng-container>
              </span>
            </ng-container>
            <ng-container *ngIf="docElement.dokTrackingPortalShare">
              <span flow="left" style="font-size: medium"
                    [tooltip]="getRessource('tooltip.trackingPortal')">
                <i class="fal fa-cloud"></i> -
              </span>
            </ng-container>
            {{docElement.dok_enmIdent_DokTyp >= 0 && docElement.dokGroesse > 0 ? appSvc.file.calcFileSize(docElement.dokGroesse, false) + ' - ' : ''}}
            {{docElement.dokMode}}
          </div>
        </div>
        <div class="grid-1-auto">
          <div class="list-metadata ">
            <div class="typo-right">
              {{docElement.dokLCD | excDate: 'Globals.DateTimeFormatShort'}}</div>
            <div class="typo-right">{{docElement.dokCRU}}</div>
          </div>
        </div>
        <div class="span-2">
          <div class="grid-1-auto" style="margin: 1rem 0">
            <div style="overflow: hidden">
              <strong>{{docElement.dokName}}{{docElement.dokErw}}</strong>
            </div>
            <div class="typo-right app-space-top_1">
              <ng-container *ngIf="docElement.dokPages">
                {{docElement.dokPages}} Seite(n)
              </ng-container>
            </div>
          </div>
        </div>
        <div class="span-2 list-secondary-text">{{docElement.dokBeschreibung || 'Keine Beschreibung'}}</div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #receiptTemplate let-rcptElement>
  <div class="typo-container-s-s-q typo-small"
       *ngIf="!rcptElement.rcptStatement">
    <span class="">
      {{enmSrv.getEnumerationText('ReceiptStatus', rcptElement?.rcpt_enmIdent_ReceiptStatus)}}
      - {{enmSrv.getEnumerationText('ReceiptType', rcptElement?.rcpt_enmIdent_ReceiptType)}}
    </span>
    <span></span>
    <q></q>
    <span class="app-list-row-boldline">
      {{rcptElement.rcptDate | excDate: 'dd.MM.yyyy'}}
      {{!rcptElement.rcptDate ? getRessource('EmptyColumn.rcptDate') : ''}}&nbsp;|&nbsp;
      {{rcptElement.compName && rcptElement.compName.length > 0 ? rcptElement.compName :
      getRessource('EmptyColumn.compName')}}
    </span>
    <span></span>
    <q></q>
    <span>
      {{getRcptObjectString(rcptElement)}}
    </span>
    <span></span>
    <q></q>
    <ng-container *ngIf="rcptElement.rcptReviewReasons">
      <span class="list-secondary-text app-list-text"
            [tooltip]="getReviewReasonsText(rcptElement.rcptReviewReasons).length >= 48 ? getReviewReasonsText(rcptElement.rcptReviewReasons) : ' '">
        {{enmSrv.getFieldCaption('Receipt', 'rcptReviewReasons')}}:
        {{ getReviewReasonsText(rcptElement.rcptReviewReasons).slice(0, 48) }}{{ getReviewReasonsText(rcptElement.rcptReviewReasons).length >= 48 ? '...' : ' ' }}
      </span>
      <span></span>
      <q></q>
    </ng-container>
    <ng-container *ngIf="rcptElement.rcptNetSum || rcptElement.rcptGrossSum">
      <span class="list-secondary-text app-list-text">
        {{enmSrv.getFieldCaption('Receipt', 'rcptGrossSum')}}
        : {{rcptElement.rcptGrossSum !== null ? (rcptElement.rcptGrossSum | excCurrency:'€') : '-'}}
        |
        {{enmSrv.getFieldCaption('Receipt', 'rcptTotalCorrections')}}
        : {{rcptElement.rcptTotalCorrections !== null ? (rcptElement.rcptTotalCorrections | excCurrency:'€') : '-'}}
      </span>
      <span></span>
      <q></q>
    </ng-container>
    <ng-container *ngIf="rcptElement.rcptDesc?.toString().length > 0">
      <span class="list-secondary-text app-list-text">
        {{rcptElement.rcptDesc?.toString().slice(0, 64)}}{{rcptElement.rcptDesc?.length >= 64 ?
        '...' : ''}}
      </span>
      <span></span>
      <q></q>
    </ng-container>
  </div>
</ng-template>
<ng-template #receiptStatementTemplate let-rcptElement>
  <div class="typo-container-s-s-q typo-small"
       *ngIf="rcptElement.rcptStatement">
    <span class="">
      {{enmSrv.getEnumerationText('ReceiptStatus', rcptElement.rcpt_enmIdent_ReceiptStatus)}}
    </span>
    <span></span>
    <q></q>
    <ng-container *ngIf="rcptElement.rcptStatementReason?.toString().length > 0">
      <span>
        {{rcptElement.rcptStatementReason.slice(0, 64)}}
        {{rcptElement.rcptStatementReason.length >= 64 ? '...' : ''}}
      </span>
      <span></span>
      <q></q>
    </ng-container>
    <ng-container *ngIf="rcptElement.rcptStatementText?.toString().length > 0">
      <span class="list-secondary-text">
        {{stripHtmlTags(rcptElement.rcptStatementText).slice(0, 64)}}
        {{stripHtmlTags(rcptElement.rcptStatementText).length >= 64 ? '...' : ''}}
      </span>
      <span></span>
      <q></q>
    </ng-container>
  </div>
</ng-template>
<ng-template #rcptAllFolders>
  <ng-container *ngFor="let folder of getRcptFolders(selectedMenuIndex); trackBy: trackByRcptFolderKey">
    <div class="grid-auto-1-auto app-space_075" style="cursor: pointer"
         (click)="toggleRcptFolder(folder)">
      <!--Header Belege Folder-->
      <i class="fal fa-folder" style="margin-right: 1.25rem"></i>
      <div> {{folder.refGroupHeadline || '-Keiner Gruppe zugeordnet-'}} ({{ folder.refItem_rcptIDs }})</div>
      <!-- Chevron Toggle -->
      <i  style="position: relative;"
          [class]="isRcptFolderExpanded(folder) ? 'search-action fal fa-chevron-down' : 'search-action fal fa-chevron-right'">
          <span *ngIf="getSelectedReceiptCount(folder) > 0"
                [tooltip]="getSelectedReceiptCount(folder) + ' Datei(en) ausgewählt'"
                class="fa-counter"
                style="font-size: 1.75rem;">
            {{getSelectedReceiptCount(folder)}}
          </span>
      </i>
    </div>
    <div *ngIf="isRcptFolderExpanded(folder)" class="flex-container app-space_025">
      <div class="flex-row">
        <!--Belege-->
        <ng-container  *ngFor="let rcptElement of folder.receipts">
          <div class="app-space-top_1 app-space-left_1">
            <!--Belege-->
            <div class="md3-card-on-surface list-row list-row-1-auto app-list app-cursor-pointer"
                 style="padding: .5rem; width: 25rem; overflow: hidden; position: relative; min-height: 10rem;"
                 (dblclick)="rcptConfig.receiptList.onDblClickCheckView(rcptElement.rcptID, rcptElement.rcptStatement)">
              <ng-container *ngTemplateOutlet="receiptTemplate; context: { $implicit: rcptElement }"></ng-container>
              <ng-container *ngTemplateOutlet="receiptStatementTemplate; context: { $implicit: rcptElement }"></ng-container>
              <div class="list-metadata ">
                <div class="typo-right">{{rcptElement.rcptLCD | excDate: 'Globals.DateTimeFormatShort'}}</div>
                <div class="typo-right">{{rcptElement.rcptLCU}}</div>
                <div class="typo-right app-space-top_1">
                  <i [tooltip]="'Vorschau Beleg'" class="search-action fal fa-eye" (click)="openPreviewOverlay(rcptElement)"></i>
                  <i class="fal fa-fw fa-comments search-action"
                     (click)="openMessageModal('RECEIPT', rcptElement.rcptID)"
                     [tooltip]="getRessource('Tooltip.Messages')" flow="left">
                  </i>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>
</ng-template>

<div class="content grid-auto-1">
  <!--DocCategoryNav-->
  <div class="layout-auto-1">
    <div class="md-menu-break">{{selectKey === 'auID' ? 'Auftrag' : 'Vorgang'}} {{vorgOrAuNr}}</div>
    <div class="content">
      <ng-container *ngFor="let item of sidemenu; let i = index">
        <button
          (click)="selectMenuItem(i)"
          class="md-menu-item"
          [ngClass]="{ 'active': selectedMenuIndex === i }"
          [disabled]="item.disabled">
          <i class="{{item.icon}}" style="position: relative;">
              <span *ngIf="item.selectedCount"
                    [tooltip]="item.selectedCount + ' Datei(en) ausgewählt'" flow="right" style="font-size: 1.75rem;"
                    class="fa-counter">{{item.selectedCount}}</span></i>
          {{item.caption}}
        </button>
        <!-- Folder Subitems: Nur unter Anhänge & Belege -->
        <ng-container *ngIf="i === 3 && item.subItems?.length">
          <div
            *ngFor="let folder of item.subItems"
            class="md-menu-item" style="padding-left: 2rem;"
            [ngClass]="{ 'active': getAttFolderKey(folder) === attConfig.selectedFolderKey }"
            (click)="selectAttSubFolder(folder)">
            <i class="fal fa-folder">
              <span *ngIf="folder.selectedCount" class="fa-counter">{{folder.selectedCount}}</span>
            </i>
            {{ folder.source === 'document' ? enmSrv.getEnumerationText('DokTyp', folder.dok_enmIdent_DokTyp)
            : (folder.source === 'report' ? getRessource('reportFolder')
              : getRessource('questFolder')) }}
            ({{folder.dokFolderCount}})
          </div>
        </ng-container>
        <ng-container *ngIf="i === 4 && item.subItems?.length">
          <div *ngFor="let folder of item.subItems"
               class="md-menu-item" style="padding-left: 2rem;"
               [ngClass]="{ 'active': getRcptFolderKey(folder) === rcptConfig.selectedFolderKey && !folder.refGroupStatement && selectedMenuIndex === i}"
               (click)="selectRcptSubFolder(folder, i)">
            <i class="fal fa-folder"></i>
            {{folder.refGroupHeadline || '-Keiner Gruppe zugeordnet-'}} ({{folder.refItem_rcptIDs}})
          </div>
        </ng-container>
        <ng-container *ngIf="i === 5 && item.subItems?.length">
          <div *ngFor="let folder of item.subItems"
               class="md-menu-item" style="padding-left: 2rem;"
               [ngClass]="{ 'active': getRcptFolderKey(folder) === rcptConfig.selectedFolderKey  && folder.refGroupStatement && selectedMenuIndex === i}"
               (click)="selectRcptSubFolder(folder, i)">
            <i class="fal fa-folder"></i>
            {{folder.refGroupHeadline || '-Keiner Gruppe zugeordnet-'}} ({{folder.refItem_rcptIDs}})
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
  <div class="content layout-auto-1 app-border-left">
    <!--Kalkulation-->
    <ng-container *ngIf="selectedMenuIndex === 0">
      <!-- Kalkulation Search Header -->
      <exg-search-bar (Search)="calcConfig.calcList.search($event)"
                      [placeholder]="getRessource('SearchHolder')"
                      class="span-layout">
        <ng-template #rightTemplate>
          <i (click)="calcConfig.calcList.loadData();"
             [tooltip]="getRessource('tooltip.Sync')"
             class="search-action fal fa-sync"></i>
        </ng-template>
      </exg-search-bar>
      <div class="flex-container content">
        <!--Kalkulation Content-->
        <div class="content flex-row" *ngIf="calcConfig.calcList.state === 0">
          <ng-container *ngFor="let cvElement of calcConfig.calcList.data">
            <div class="grid-auto-1 app-space-top_1">
              <!--Selection Checkbox-->
              <div class="app-checkbox-multiSelection">
                <exg-checkbox [id]="cvElement.cvID + 'selection'"
                              [(ngModel)]="cvElement.selectedInUI"
                              (ngModelChange)="cvSelection(cvElement, $event)"
                disabled="{{cvElement.cvCalculationVersionStatus_enmIdent !== 10}}">
                </exg-checkbox>
              </div>
              <!--Kalkulation-->
              <div class="md3-card-on-surface" style="padding: .5rem; width: 20rem; overflow: hidden; position: relative;">
                <ng-container *ngIf="cvElement">
                  <div class="grid-auto-1">
                    <div [ngStyle]="{'opacity': cvElement.cvCalculationVersionStatus_enmIdent !== 10 ? '0.5' : '1'}">
                      <i class="fa-duotone fa-2x fa-file-spreadsheet" style="margin: 0 1.25rem; text-align: center; cursor: pointer" (click)="openCalculationVersion(cvElement)"></i>
                    </div>
                    <div class="layout-auto-1-auto-grid-1-auto grid typo-small">
                      <div class="list-metadata" style="margin-left: 0;"
                           [ngStyle]="{'opacity': cvElement.cvCalculationVersionStatus_enmIdent !== 10 ? '0.5' : '1'}">
                        <div>{{enmSrv.getEnumerationText('CalculationVersionStatus', cvElement.cvCalculationVersionStatus_enmIdent)}}</div>
                      </div>
                      <div class="grid-1-auto"
                           [ngStyle]="{'opacity': cvElement.cvCalculationVersionStatus_enmIdent !== 10 ? '0.5' : '1'}">
                        <div class="list-metadata">
                          <div class="typo-right">{{cvElement.cvLCD | excDate: getGlobal('DateTimeFormatShort')}}</div>
                          <div class="typo-right">{{cvElement.cvLCU}}</div>
                        </div>
                      </div>
                      <div class="span-2" style="margin: 1rem 0"
                           [ngStyle]="{'opacity': cvElement.cvCalculationVersionStatus_enmIdent !== 10 ? '0.5' : '1'}">
                        <div class="grid-1-auto">
                          <div style="overflow: hidden;">
                            <strong>{{cvElement.cvName}}</strong>
                          </div>
                          <div class="typo-right">
                            {{cvElement.SheetCount}} Sheet(s)
                          </div>
                        </div>
                      </div>
                      <div class="span-2 grid-1-auto">
                        <div class="list-secondary-text"
                             [ngStyle]="{'opacity': cvElement.cvCalculationVersionStatus_enmIdent !== 10 ? '0.5' : '1'}">{{cvElement.cvDescription || 'Keine Beschreibung'}}</div>
                        <div class="typo-right app-space-top_1">
                        <span>
                          <i *ngIf="cvElement.cvCalculationVersionStatus_enmIdent !== 10"
                             [tooltip]="'Kalkulation editieren'" class="search-action fal fa-pen" (click)="openCalculationVersionModal(cvElement)"></i>
                          <i [tooltip]="'Vorschau Kalkulation'" class="search-action fal fa-eye" (click)="openPreviewOverlay(cvElement)"></i>

                          <i class="fal fa-fw fa-comments search-action"
                             (click)="openMessageModal('CALCVERSION', cvElement.cvID)"
                             [tooltip]="getRessource('Tooltip.Messages')" flow="left">
                          </i>
                        </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </ng-container>
        </div>
        <!-- IsLoading -->
        <ng-container
          *ngTemplateOutlet="loadingempty; context: { $implicit: calcConfig.calcList.state }">
        </ng-container>
      </div>
    </ng-container>
    <!--Fragebögen-->
    <ng-container *ngIf="selectedMenuIndex === 1">
      <!-- Fragebögen Search Header -->
      <exg-search-bar (Search)="questConfig.questList.search($event)"
                      [placeholder]="getRessource('SearchHolder')"
                      class="span-layout">
        <ng-template #rightTemplate>
          <i (click)="questConfig.questList.loadData();"
             [tooltip]="getRessource('tooltip.Sync')"
             class="search-action fal fa-sync"></i>
        </ng-template>
      </exg-search-bar>
      <div class="flex-container content">
        <!--Fragebögen Content-->
        <div class="content flex-row" *ngIf="questConfig.questList.state === 0">
          <ng-container *ngFor="let qverElement of questConfig.questList.data">
            <div class="grid-auto-1 app-space-top_1">
              <!--Selection Checkbox-->
              <div class="app-checkbox-multiSelection">
                <exg-checkbox [id]="qverElement.qverID + 'selection'"
                              [(ngModel)]="qverElement.selectedInUI"
                              (ngModelChange)="qverSelection(qverElement, $event)"
                              disabled="{{qverElement.qverQuestionnaireVersionStatus_enmIdent !== 10}}">
                </exg-checkbox>
              </div>
              <!--Fragebögen-->
              <div class="md3-card-on-surface" style="padding: .5rem; width: 20rem; overflow: hidden; position: relative;">
                <ng-container *ngIf="qverElement">
                  <div class="grid-auto-1 app-cursor-pointer"
                       (dblclick)="openQuestionnaireVersion(qverElement)">
                    <div [ngStyle]="{'opacity': qverElement.qverQuestionnaireVersionStatus_enmIdent !== 10 ? '0.5' : '1'}">
                      <i class="fa-duotone fa-2x fa-clipboard-list" style="margin: 0 1.25rem; text-align: center; cursor: pointer" (click)="openQuestionnaireVersion(qverElement)"></i>
                    </div>
                    <div class="layout-auto-1-auto-grid-1-auto grid typo-small">
                      <div class="list-metadata" style="margin-left: 0;"
                           [ngStyle]="{'opacity': qverElement.qverQuestionnaireVersionStatus_enmIdent !== 10 ? '0.5' : '1'}">
                        <div>{{enmSrv.getEnumerationText('QuestionnaireVersionStatus', qverElement.qverQuestionnaireVersionStatus_enmIdent)}}</div>
                      </div>
                      <div class="grid-1-auto"
                           [ngStyle]="{'opacity': qverElement.qverQuestionnaireVersionStatus_enmIdent !== 10 ? '0.5' : '1'}">
                        <div class="list-metadata">
                          <div class="typo-right">{{qverElement.qverLCD | excDate: getGlobal('DateTimeFormatShort')}}</div>
                          <div class="typo-right">{{qverElement.qverLCU}}</div>
                        </div>
                      </div>
                      <div class="span-2" style="margin: 1rem 0"
                           [ngStyle]="{'opacity': qverElement.qverQuestionnaireVersionStatus_enmIdent !== 10 ? '0.5' : '1'}">
                        <div class="grid-1-auto">
                          <div style="overflow: hidden;">
                            <strong>{{qverElement.qverName}}</strong>
                          </div>
                          <div class="typo-right">
                            <!--{{qverElement.PageCount}} Seite(n)-->
                          </div>
                        </div>
                      </div>
                      <div class="list-secondary-text"
                           [ngStyle]="{'opacity': qverElement.qverQuestionnaireVersionStatus_enmIdent !== 10 ? '0.5' : '1'}">{{qverElement.qverDescription || 'Keine Beschreibung'}}</div>
                      <div class="typo-right app-space-top_1">
                        <span>
                          <i [tooltip]="'Fragebogen editieren'" class="search-action fal fa-pen" (click)="openModalQuestionnaireVersion(qverElement)"></i>
                          <i [tooltip]="'Vorschau Fragebogen'" class="search-action fal fa-eye" (click)="openPreviewOverlay(qverElement)"></i>

                          <i class="fal fa-fw fa-comments search-action"
                             (click)="openMessageModal('QUESTVERSION', qverElement.qverID)"
                             [tooltip]="getRessource('Tooltip.Messages')" flow="left">
                          </i>
                        </span>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </ng-container>
        </div>
        <!-- IsLoading -->
        <ng-container
          *ngTemplateOutlet="loadingempty; context: { $implicit: questConfig.questList.state }">
        </ng-container>
      </div>
    </ng-container>
    <!--Bilddokumentation-->
    <ng-container *ngIf="selectedMenuIndex === 2">
      <!-- BildDokumentation Search Header -->
      <exg-search-bar (Search)="photoDocConfig.photoDocList.search($event)"
                      [placeholder]="getRessource('SearchHolder')"
                      class="span-layout">
        <ng-template #rightTemplate>
          <i (click)="photoDocConfig.photoDocList.loadData();"
             [tooltip]="getRessource('tooltip.Sync')"
             class="search-action fal fa-sync"></i>
        </ng-template>
      </exg-search-bar>
      <div class="flex-container content">
        <!--BildDokumentation Content-->
        <div class="content flex-row  " *ngIf="photoDocConfig.photoDocList.state === 0">
          <ng-container *ngFor="let pdElement of photoDocConfig.photoDocList.data">
            <div class="grid-auto-1 app-space-top_1">
              <!--Selection Checkbox-->
              <div class="app-checkbox-multiSelection">
                <exg-checkbox [id]="pdElement.pdID + 'selection'"
                              [(ngModel)]="pdElement.selectedInUI"
                              (ngModelChange)="pdSelection(pdElement, $event)"
                              disabled="{{pdElement.pdPhotoDocumentationStatus_enmIdent !== 10}}">
                </exg-checkbox>
              </div>
              <!--BildDokumentation-->
              <div class="md3-card-on-surface" style="padding: .5rem; width: 20rem; overflow: hidden; position: relative;">
                <ng-container *ngIf="pdElement">
                  <div class="grid-auto-1">
                    <div [ngStyle]="{'opacity': pdElement.pdPhotoDocumentationStatus_enmIdent !== 10 ? '0.5' : '1'}">
                      <i class="fa-duotone fa-2x fa-file-image" style="margin: 0 1.25rem; text-align: center; cursor: pointer" (click)="openPhotoDocPreview(pdElement)"></i>
                    </div>
                    <div class="layout-auto-1-auto-grid-1-auto grid typo-small">
                      <div class="list-metadata" style="margin-left: 0;"
                           [ngStyle]="{'opacity': pdElement.pdPhotoDocumentationStatus_enmIdent !== 10 ? '0.5' : '1'}">
                        <div>{{enmSrv.getEnumerationText('PhotoDocumentationStatus', pdElement.pdPhotoDocumentationStatus_enmIdent)}}</div>
                      </div>
                      <div class="grid-1-auto"
                           [ngStyle]="{'opacity': pdElement.pdPhotoDocumentationStatus_enmIdent !== 10 ? '0.5' : '1'}">
                        <div class="list-metadata">
                          <div class="typo-right">{{pdElement.pdLCD | excDate: getGlobal('DateTimeFormatShort')}}</div>
                          <div class="typo-right">{{pdElement.pdLCU}}</div>
                        </div>
                      </div>
                      <div class="span-2" style="margin: 1rem 0"
                           [ngStyle]="{'opacity': pdElement.pdPhotoDocumentationStatus_enmIdent !== 10 ? '0.5' : '1'}">
                        <div class="grid-1-auto">
                          <div style="overflow: hidden;">
                            <strong>{{pdElement.pdName}}</strong>
                          </div>
                          <div class="typo-right">
                            {{pdElement.PageCount}} Seite(n)
                          </div>
                        </div>
                      </div>
                      <div class="span-2 grid-1-auto">
                        <div class="list-secondary-text"
                             [ngStyle]="{'opacity': pdElement.pdPhotoDocumentationStatus_enmIdent !== 10 ? '0.5' : '1'}">{{pdElement.pdDescription || 'Keine Beschreibung'}}</div>
                        <div class="typo-right app-space-top_1">
                        <span>
                          <i [tooltip]="'Bilddokumentation editieren'" class="search-action fal fa-pen" (click)="openPhotoDocEditTextModal(false, pdElement)"></i>
                          <i [tooltip]="'Vorschau Bilddokumentation'" class="search-action fal fa-eye" (click)="openPreviewOverlay(pdElement)"></i>

                          <i class="fal fa-fw fa-comments search-action"
                             (click)="openMessageModal('PHOTODOC', pdElement.pdID)"
                             [tooltip]="getRessource('Tooltip.Messages')" flow="left">
                          </i>
                        </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </ng-container>
        </div>
        <!-- IsLoading -->
        <ng-container
          *ngTemplateOutlet="loadingempty; context: { $implicit: photoDocConfig.photoDocList.state }">
        </ng-container>
      </div>
    </ng-container>
    <!--Anhänge-->
    <ng-container *ngIf="selectedMenuIndex === 3">
      <exg-search-bar (Search)="attConfig.attachmentJagTable.search($event)"
                      [placeholder]="getRessource('SearchHolder')"
                      class="span-layout">
        <ng-template #rightTemplate>
          <i (click)="attConfig.attachmentJagTable.loadData()"
             [tooltip]="getRessource('tooltip.Sync')"
             class="search-action fal fa-sync"></i>
        </ng-template>
      </exg-search-bar>
      <ng-container *ngIf="attConfig.attachmentJagTable.state === 0">
        <!--Single Folder View-->
        <ng-container *ngIf="attConfig.selectedFolderKey; else attElse">
          <ng-container *ngFor="let folder of attConfig.attachmentJagTable.jagdata">
            <ng-container *ngIf="getAttFolderKey(folder) === attConfig.selectedFolderKey">
              <div class="content">
                <!--Content-->
                <div class="flex-container content" *ngIf="attConfig.attachmentJagTable.state === 0">
                  <div class="flex-row content">
                    <!--Dokumente-->
                    <ng-container  *ngFor="let docElement of folder.documents">
                      <div class="grid-auto-1 app-space-top_1">
                        <!--Selection Checkbox-->
                        <div class="app-checkbox-multiSelection"
                             [ngStyle]="{'padding-left': folder.dok_enmIdent_DokTyp === -1 ? '2.75em' : '0'}">
                          <exg-checkbox *ngIf="folder.dok_enmIdent_DokTyp !== -1"
                                        [id]="docElement.dokID + 'selection'"
                                        [(ngModel)]="docElement.selectedInUI"
                                        (ngModelChange)="attSelection(docElement, $event)">
                          </exg-checkbox>
                        </div>
                        <!--Dokumente-->
                        <ng-container
                          *ngTemplateOutlet="docTemplate; context: { $implicit: docElement }">
                        </ng-container>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
        <!--All Folder View-->
        <ng-template #attElse>
          <div class="content">
            <!--Content-->
            <div class="content">
              <ng-container *ngFor="let folder of attConfig.attachmentJagTable.jagdata; trackBy: trackByAttFolderKey">
                <div class="grid-auto-1-auto app-space_075" style="cursor: pointer" (click)="toggleAttFolder(folder)">
                  <!--Header Doks Reports Fragebögen-->
                  <i class="fal fa-folder" style="margin-right: 1.25rem"></i>
                  <div [ngSwitch]="folder.source">
                    <div *ngSwitchCase="'document'"> {{ enmSrv.getEnumerationText('DokTyp', folder.dok_enmIdent_DokTyp) }} ({{ folder.dokFolderCount }})</div>
                    <div *ngSwitchCase="'report'"> {{ getRessource('reportFolder') }} ({{ folder.dokFolderCount }})</div>
                    <div *ngSwitchCase="'Fragebogen'"> {{ getRessource('questFolder') }} ({{ folder.dokFolderCount }})</div>
                  </div>
                  <!-- Chevron Toggle -->
                  <i  style="position: relative;"
                      [class]="isAttFolderExpanded(folder) ? 'search-action fal fa-chevron-down' : 'search-action fal fa-chevron-right'">
                    <span *ngIf="getSelectedDocumentCount(folder) > 0"
                          [tooltip]="getSelectedDocumentCount(folder) + ' Datei(en) ausgewählt'"
                          class="fa-counter"
                          style="font-size: 1.75rem;">
                      {{getSelectedDocumentCount(folder)}}
                    </span>
                  </i>
                </div>
                <div *ngIf="isAttFolderExpanded(folder)" class="flex-container app-space_025">
                  <div class="flex-row">
                    <!--Dokumente-->
                    <ng-container  *ngFor="let docElement of folder.documents">
                      <div class="grid-auto-1 app-space-top_1">
                        <!--Selection Checkbox-->
                        <div class="app-checkbox-multiSelection"
                             [ngStyle]="{'padding-left': folder.dok_enmIdent_DokTyp === -1 ? '2.75em' : '0'}">
                          <exg-checkbox *ngIf="folder.dok_enmIdent_DokTyp !== -1"
                                        [id]="docElement.dokID + 'selection'"
                                        [(ngModel)]="docElement.selectedInUI"
                                        (ngModelChange)="attSelection(docElement, $event)">
                          </exg-checkbox>
                        </div>
                        <!--Dokumente-->
                        <ng-container
                          *ngTemplateOutlet="docTemplate; context: { $implicit: docElement }">
                        </ng-container>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </ng-template>
      </ng-container>
      <!-- IsLoading -->
      <ng-container
        *ngTemplateOutlet="loadingempty; context: { $implicit: attConfig.attachmentJagTable.state }">
      </ng-container>
    </ng-container>
    <!--Belege-->
    <ng-container *ngIf="selectedMenuIndex === 4 || selectedMenuIndex === 5">
      <!-- Belege Search Header -->
      <exg-search-bar (Search)="rcptConfig.receiptList.search($event)"
                      [placeholder]="getRessource('SearchHolder')"
                      class="span-layout">
        <ng-template #rightTemplate>
          <i (click)="rcptConfig.receiptList.loadData();"
             [tooltip]="getRessource('tooltip.Sync')"
             class="search-action fal fa-sync"></i>
        </ng-template>
      </exg-search-bar>
      <div class="content">
        <!--Belege Content-->
        <div class="content" *ngIf="rcptConfig.receiptList.state === 0">
          <!--Single Folder View-->
          <ng-container *ngIf="rcptConfig.selectedFolderKey; else rcptAllFolders">
            <ng-container *ngFor="let folder of getRcptFolders(selectedMenuIndex)">
              <ng-container *ngIf="getRcptFolderKey(folder) === rcptConfig.selectedFolderKey">
                <div class="content">
                  <!--Content-->
                  <div class="flex-container content">
                    <div class="flex-row content">
                      <!--Belege-->
                      <ng-container  *ngFor="let rcptElement of folder.receipts">
                        <div class="app-space-top_1 app-space-left_1">
                          <!--Belege-->
                          <div class="md3-card-on-surface list-row list-row-1-auto app-list app-cursor-pointer"
                               style="padding: .5rem; width: 25rem; overflow: hidden; position: relative; min-height: 5rem;"
                               (dblclick)="rcptConfig.receiptList.onDblClickCheckView(rcptElement.rcptID, rcptElement.rcptStatement)">
                            <ng-container *ngTemplateOutlet="receiptTemplate; context: { $implicit: rcptElement }"></ng-container>
                            <ng-container *ngTemplateOutlet="receiptStatementTemplate; context: { $implicit: rcptElement }"></ng-container>
                            <div class="list-metadata ">
                              <div class="typo-right">{{rcptElement.rcptLCD | excDate: 'Globals.DateTimeFormatShort'}}</div>
                              <div class="typo-right">{{rcptElement.rcptLCU}}</div>
                              <div class="typo-right app-space-top_1">
                                <i [tooltip]="'Vorschau Beleg'" class="search-action fal fa-eye" (click)="openPreviewOverlay(rcptElement)"></i>
                                <i class="fal fa-fw fa-comments search-action"
                                   (click)="openMessageModal('RECEIPT', rcptElement.rcptID)"
                                   [tooltip]="getRessource('Tooltip.Messages')" flow="left">
                                </i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
        </div>
        <!-- IsLoading -->
        <ng-container *ngTemplateOutlet="loadingempty; context: { $implicit: rcptConfig.receiptList.state }"></ng-container>
      </div>
    </ng-container>
    <div></div>
  </div>
</div>
